import { jsxs as o, jsx as t } from "react/jsx-runtime";
import { useTranslation as d } from "react-i18next";
import n from "../../../../elements/link-wrapper/link-wrapper.js";
import h from "../mobile-featured-link/mobile-featured-link.js";
import M from "../mobile-menu-action-bar/mobile-menu-action-bar.js";
import e from "./mobile-first-level-menu.module.less.js";
import { isArrayWithItems as l } from "../../../../../helpers/array-helper.js";
const L = ({
  menuItems: s,
  featureLinks: a,
  onClickCategory: m,
  onClickClose: p
}) => {
  const { t: c } = d(), u = s.some((r) => r.url === "/");
  return /* @__PURE__ */ o("div", { className: e.wrapper, children: [
    /* @__PURE__ */ o("div", { className: e.innerWrapper, children: [
      /* @__PURE__ */ o("div", { className: e.topItemsWrapper, children: [
        !u && /* @__PURE__ */ t(
          n,
          {
            className: [e.topMenuLink, "h3 mb-0"].join(" "),
            url: "/",
            title: c("HEADER_HOME")
          },
          -1
        ),
        s.map((r, i) => l(r.links) ? /* @__PURE__ */ o("button", { onClick: () => m(i), className: e.topMenuItem, children: [
          /* @__PURE__ */ t("div", { className: "h3 mb-0", children: r.title }),
          /* @__PURE__ */ t("span", { className: [e.topMenuItemIcon, "ui-icon-arrow-right bold"].join(" ") })
        ] }, i) : /* @__PURE__ */ t(
          n,
          {
            className: [e.topMenuLink, "h3 mb-0"].join(" "),
            url: r.url,
            title: r.title
          },
          i
        ))
      ] }),
      l(a) && /* @__PURE__ */ t("div", { className: e.featureLinksWrapper, children: a.map((r, i) => /* @__PURE__ */ t(h, { ...r }, i)) })
    ] }),
    /* @__PURE__ */ t(M, { onClickClose: p })
  ] });
};
export {
  L as default
};
